import { Grid, Typography, Grow } from "@mui/material";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../../app/hooks";
import {
  selectCalculatorState,
  setHealthData,
  setOutlaysInnerAllowNextStep,
  setActiveOutlaysInnerStep,
  setTotalHealth,
  setTotal,
  setActiveStep,
} from "../../../../../../calculatorSlice";
import { IHealthData } from "../../../../../../../../lib/interfaces/IFixedOutlay";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import sum from "../../../../../../../../lib/utils/sum";
import { NumberFormatCustom } from "../../../../../FormattedInputs";
import ArrowLeft from "../../../../../../assets/arrow-left.svg";
import ArrowRight from "../../../../../../assets/arrow-right.svg";
import { CustomTextFiled } from "../../../../../CustomTextFiled";

function HealthForm() {
  const dispatch = useAppDispatch();
  const CalculatorState = useAppSelector(selectCalculatorState);
  const { healthData } = useAppSelector(selectCalculatorState);

  const handleBackClick = () => {
    if (CalculatorState.allowedSteps > 0) {
      if (
        CalculatorState.outlaysInnerAllowedSteps >= 0 &&
        CalculatorState.outlaysInnerActiveStep === 0
      ) {
        dispatch(setActiveStep(0));
      }
      if (
        CalculatorState.outlaysInnerAllowedSteps > 0 &&
        CalculatorState.outlaysInnerActiveStep > 0
      ) {
        dispatch(
          setActiveOutlaysInnerStep(CalculatorState.outlaysInnerActiveStep - 1)
        );
      }
    }
  };
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<IHealthData>({
    defaultValues: healthData,
  });
  const onSubmit: SubmitHandler<IHealthData> = (data) => {
    delete data.healthTotal;
    const sumWithInitialValue = sum(data);
    dispatch(setHealthData(data));
    dispatch(setTotalHealth(sumWithInitialValue));
    dispatch(setTotal());
    dispatch(setOutlaysInnerAllowNextStep(5));
    dispatch(setActiveOutlaysInnerStep(4));
  };
  return (
    <Grid
      sx={{ textAlign: "center", display: "grid", placeItems: "center" }}
      container
    >
      <Grid item>
        <br />
        <Grow timeout={{ enter: 900, exit: 100 }} in={true}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <h3
                style={{
                  textAlign: "center",
                  fontWeight: "700",
                  width: "100%",
                  fontSize: "1.75rem",
                  marginBottom: "0.425rem",
                  padding: 0,
                  marginTop: "0.325rem",
                }}
              >
                בריאות{" "}
              </h3>
            </div>
            <br />
            <Controller
              name="hmo"
              control={control}
              render={({ field }) => (
                <CustomTextFiled
                  InputProps={{
                    inputComponent: NumberFormatCustom as any,
                    disableUnderline: true,
                  }}
                  {...field}
                  helperText={errors.hmo && "חובה להזין ערך"}
                  sx={{
                    marginBottom: "1rem",
                    width: "90%",
                    textAlign: "center",
                    margin: "0.25rem auto",
                  }}
                  id="filled-basic"
                  label="קופת חולים"
                  variant="filled"
                />
              )}
            />
            <Controller
              name="insurance"
              control={control}
              render={({ field }) => (
                <CustomTextFiled
                  InputProps={{
                    inputComponent: NumberFormatCustom as any,
                    disableUnderline: true,
                  }}
                  {...field}
                  error={!!errors.insurance}
                  helperText={errors.insurance && "חובה להזין ערך"}
                  sx={{
                    marginBottom: "1rem",
                    width: "90%",
                    textAlign: "center",
                    margin: "0.25rem auto",
                  }}
                  id="filled-basic"
                  label=" ביטוחים"
                  variant="filled"
                />
              )}
            />
            <br />
            <div
              style={{
                display: "grid",
                placeItems: "center",
                alignItems: "center",
              }}
            >
              <br />
              <div
                style={{
                  display: "grid",
                  placeItems: "center",
                  alignItems: "center",
                  gridTemplateColumns: "auto auto",
                  alignContent: "center",
                  justifyContent: "center",
                  gap: "1rem",
                }}
              >
                <button onClick={handleBackClick} className="back">
                  <img
                    src={ArrowRight}
                    alt="arrow"
                    style={{ marginBottom: "0.25rem" }}
                  />
                  <Typography
                    sx={{ fontSize: "1.2rem", color: "black" }}
                    display="block"
                    gutterBottom
                  >
                    הקודם
                  </Typography>
                </button>
                <button className="btn next" type="submit">
                  <Typography
                    sx={{ fontSize: "1.2rem" }}
                    display="block"
                    gutterBottom
                  >
                    הבא
                  </Typography>
                  <img
                    src={ArrowLeft}
                    alt="arrow"
                    style={{ marginBottom: "0.25rem" }}
                  />
                </button>
              </div>
            </div>
          </form>
        </Grow>
        <br />
      </Grid>
    </Grid>
  );
}

export default HealthForm;
